import React from "react";
import { motion } from "framer-motion";
import { Overline, ease } from "./primitives";

export default function PageHero({ overline, title, subtitle, chapter }) {
  return (
    <section className="px-6 md:px-12 lg:px-20 pt-20 pb-16 border-b border-border relative grain overflow-hidden">
      <div className="mx-auto max-w-[1400px] relative z-10">
        {overline && <Overline>{chapter ? `${chapter} — ` : ""}{overline}</Overline>}
        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease }}
          className="display text-5xl md:text-7xl text-botanical mt-5 max-w-4xl"
          data-testid="page-title"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease, delay: 0.15 }}
            className="mt-6 max-w-2xl text-lg text-muted-foreground font-light leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
